import React, {Component} from 'react'
import LinkWithTooltip from '../../tooltip';
import _ from 'lodash'
import ResponsiveManager from '../../ResponsiveManager'

class Number extends Component {

  constructor(props){
    super(props)

    this.state = {
      active: 'md'
    }
  }

  onChangeHandle(event){
    const { input: { value, onChange, name }, params } = this.props
    
    if(params.responsive){
      if(_.isObject(value)){
        let newValue = Object.assign({},value)
        newValue[event.target.dataset.device] = event.target.value
        onChange(newValue);
      } else {
        let newTempValue = {
          md: value,
          sm: '',
          xs: '',
        }
        newTempValue[event.target.dataset.device] = event.target.value
        onChange(newTempValue);
      }

    } else {
      onChange(event.target.value);
    }
    
  }

  render(){
    const { input, params, responsiveDevice } = this.props

    const { active } = this.state
    
    var activeClassName = 'sp-pagebuilder-device-tabs sp-pagebuilder-device-'+responsiveDevice;
    var activeClassContainer = 'sppb-responsive-inputs sp-pagebuilder-device-'+responsiveDevice;
    
    return(
      <div className="sp-pagebuilder-form-group">
        <label>
          { params.title }
          {
            typeof params.desc != 'undefined' && params.desc != '' &&
            <LinkWithTooltip tooltip={params.desc} position="top" title={params.title}>
              <i className="fa fa-question-circle" />
            </LinkWithTooltip>
          }
          {
            params.responsive &&
            <ul className={activeClassName}>
              <li><i className="fa fa-laptop md" onClick={e => {
                  ResponsiveManager.setDevice('md');
                }}></i></li>
              <li><i className="fa fa-tablet sm" onClick={e => {
                  ResponsiveManager.setDevice('sm');
                }}></i></li>
              <li><i className="fa fa-mobile xs" onClick={e => {
                  ResponsiveManager.setDevice('xs');
                }}></i></li>
            </ul>
          }
        </label>
        {
          params.responsive &&
          <div className={activeClassContainer}>
            <input value={input.value.md} data-device="md" type="number" className="sp-pagebuilder-form-control sp-pagebuilder-addon-input md" autoComplete="off" onChange={ this.onChangeHandle.bind(this) } />
            <input value={input.value.sm} data-device="sm" type="number" className="sp-pagebuilder-form-control sp-pagebuilder-addon-input sm" autoComplete="off" onChange={ this.onChangeHandle.bind(this) } />
            <input value={input.value.xs} data-device="xs" type="number" className="sp-pagebuilder-form-control sp-pagebuilder-addon-input xs" autoComplete="off" onChange={ this.onChangeHandle.bind(this) } />
          </div>
        }
        {
          !params.responsive &&
          <input {...input} type="number" className="sp-pagebuilder-form-control sp-pagebuilder-addon-input" autoComplete="off" onChange={ this.onChangeHandle.bind(this) } />
        }
        
      </div>
    )
  }
}

export default Number;



// WEBPACK FOOTER //
// ./src/helpers/form/types/Number.js